import { createShader, colorUniform } from "./ShaderBase.js";

export const blender3DShader = createShader({
  customizable: [
    { uniform: "uColor1", label: "Color 1", default: "#4d80cc" },
    { uniform: "uColor2", label: "Color 2", default: "#9966b3" },
    { uniform: "uColor3", label: "Color 3", default: "#cc9966" },
    { uniform: "uColor4", label: "Color 4", default: "#66b399" },
  ],

  uniforms: {
    uPixelSize: { value: 32.0 },
    uScale: { value: 8.0 },
    uSpeed: { value: 0.3 },
    uColor1: colorUniform({ r: 0.3, g: 0.5, b: 0.8 }),
    uColor2: colorUniform({ r: 0.6, g: 0.4, b: 0.7 }),
    uColor3: colorUniform({ r: 0.8, g: 0.6, b: 0.4 }),
    uColor4: colorUniform({ r: 0.4, g: 0.7, b: 0.6 }),
    uNoiseStrength: { value: 0.05 },
  },

  fragmentUniforms: `
    uniform vec3 uColor1;
    uniform vec3 uColor2;
    uniform vec3 uColor3;
    uniform vec3 uColor4;
    uniform float uNoiseStrength;
  `,

  fragmentBody: `
    // Gradient based on position and time
    float gradientOffset = uTime;
    float gradientFactor = (pixelatedPos.y + gradientOffset) * 0.1 +
                          pixelatedPos.x * 0.01 +
                          pixelatedPos.z * 0.01 + 0.01;
    gradientFactor = fract(gradientFactor);

    // Mix colors based on gradient
    vec3 baseColor;
    if (gradientFactor < 0.33) {
      baseColor = mix(uColor1, uColor2, gradientFactor * 3.0);
    } else if (gradientFactor < 0.66) {
      baseColor = mix(uColor2, uColor3, (gradientFactor - 0.33) * 3.0);
    } else {
      baseColor = mix(uColor3, uColor4, (gradientFactor - 0.66) * 3.0);
    }

    // Add noise variation
    float noise = snoise(animatedPos);
    float normalizedNoise = (noise + 1.0) * 0.5;
    vec3 finalColor = baseColor + (normalizedNoise * uNoiseStrength);

    gl_FragColor = vec4(finalColor, 1.0);
  `,
});
